import { useEffect, useState } from 'react';

/**
 * SWITCHED OFF BY AN ADMINISTRATOR.
 *
 * Gordon: "if an admin has deactivated a person directly in Jarvis it should
 * block them."
 *
 * The server says so two ways: /auth/me answers { deactivated: true }, and
 * every other request answers 403 { reason: 'deactivated' } (backend
 * lib/blocked.js). Either one, from anywhere in the app, lands here, and the
 * app swaps everything it shows for one calm page (components/
 * AccessSwitchedOff) - not the sign-in page, because signing in again is
 * exactly what would not help: Microsoft still knows them, the quiet
 * sign-in would succeed, the server would refuse, and round it goes.
 *
 * In memory only, on purpose. A reload asks the server again, so the moment
 * an administrator switches them back on, the next launch simply works.
 */
export const BLOCKED_REASON = 'deactivated';

let blocked = false;
const listeners = new Set();

export function isBlocked() { return blocked; }

export function markBlocked() {
  if (blocked) return;
  blocked = true;
  listeners.forEach((fn) => {
    try { fn(true); } catch { /* a listener must not break a request */ }
  });
}

/** Is this an answer saying the caller has been switched off? */
export function isBlockedAnswer(status, body) {
  if (!body || typeof body !== 'object') return false;
  if (status === 403 && body.reason === BLOCKED_REASON) return true;
  // /auth/me, which answers 200 so the app can read why.
  return body.deactivated === true && body.reason === BLOCKED_REASON;
}

export function useBlocked() {
  const [b, setB] = useState(blocked);
  useEffect(() => {
    const fn = () => setB(true);
    listeners.add(fn);
    if (blocked) setB(true);
    return () => { listeners.delete(fn); };
  }, []);
  return b;
}
